export default "__VITE_ASSET__B7F2B1Z0__"